/**
 * Checks if a hostname matches an allowed Vercel deployment URL.
 * This includes:
 * - Production: cc-shopping-client.vercel.nerdwallet.biz
 * - Stage: cc-shopping-client.vercel.stage.nerdwallet.biz
 * - Preview PRs: cc-shopping-client-pr-{number}(-{environment})?.vercel.stage.nerdwallet.biz
 *   e.g. cc-shopping-client-pr-123-preview-wp-staging.vercel.stage.nerdwallet.biz
 */
export function isVercelHostname(hostname: string): boolean {
  return (
    hostname.endsWith('.vercel.nerdwallet.biz') || hostname.endsWith('.vercel.stage.nerdwallet.biz')
  );
}

export function isAllowedVercelUrl(incomingHeaders: Headers): boolean {
  const host = incomingHeaders.get('host') || incomingHeaders.get('x-forwarded-host') || '';

  return isVercelHostname(host);
}
